import React from 'react'
import PostMetadata from './PostMetadata'

const ArticleHeader = ({ post }) => (
	<header className="max-w-screen-md mx-auto text-center">
		<h1 className="h1 font-normal leading-tight">{post.title}</h1>
		<PostMetadata className="mt-4" {...post} />
	</header>
)

export default ArticleHeader
